import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    name: {
        // field
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
